// @flow
import React from 'react';
import { FieldWrapper } from 'speed-js-react-web';
import BaseSelect from 'esm-web-pro/components/forms/fields/BaseSelect';
import CustomTitle from '../../../components/layout/sidePanel/CustomTitle';


type Props = {
    resources: Array,
    additionalResources: Array,
    values: Array,
    secondaryFilterValues: Object,
    onChange: Function,
    onChangeSecondary: Function,
    setFilterValues: Function,
    setAdditionalFiltersValues: Function,
    title: String,
    titles: Object,
}

const FilterObjectsSidePanelFields = (props: Props) => {
    const {
        resources, additionalResources, values, onChange, onChangeSecondary, secondaryFilterValues,
        setAdditionalFiltersValues, setFilterValues, title, titles,
    } = props;

    return (
        <>
            <CustomTitle text={title} textSize="16px" marginBox="20px auto 5px 0" />
            {resources.map((resource) => (
                <FieldWrapper
                    key={resource.key}
                    label={resource.label}
                >
                    <BaseSelect
                        value={values[resource.key]}
                        // TODO: Generalize
                        resourceName={
                            resource.key === 'ref' || resource.key === 'provider_ref'
                                ? resource.resourceName : null
                        }
                        resourceArguments={resource.resourceArguments}
                        additionalFilters={resource.additionalFilters}
                        onChange={(...args) => {
                            onChange(args[0], resource.key, values, setFilterValues);
                        }}
                        labelFields={resource.labelFields}
                        minSearchLength={resource.minSearchLength || 0}
                        resourceMethod="list"
                        valueField={resource.valueField}
                        searchField={resource.searchField}
                        choices={resource.choices}
                        multi={resource.multi || false}
                        disabled={resource.disabled}
                    />
                </FieldWrapper>
            ))}

            {additionalResources && Object.keys(additionalResources).map((key1) => (

                <FieldWrapper
                    key={key1}
                >
                    <CustomTitle text={titles[key1]} textSize="13px" marginBox="20px auto 5px 0" />
                    {additionalResources[key1].map((resource) => (
                        <FieldWrapper
                            key={resource.key}
                            label={resource.label}
                        >
                            <BaseSelect
                                value={secondaryFilterValues[key1]?.[resource.key]}
                                onChange={(...args) => {
                                    onChangeSecondary(args[0], resource.key, key1, setAdditionalFiltersValues);
                                }}
                                minSearchLength={0}
                                choices={resource.choices}
                                multi={resource.multi || false}
                            />
                        </FieldWrapper>
                    ))}
                </FieldWrapper>
            ))}
        </>
    );
};

export default FilterObjectsSidePanelFields;
